<template>
  <div>
    <div v-if="display === 'minimal'" class="testimonials content">
      <h3 class="title is-5">
        {{ title }}
      </h3>
      <p
        v-for="testimonial in filteredTestimonials"
        :key="testimonial.id"
        class="testimonial"
      >
        {{ testimonial.name }}<br />
        <VuepalLink :to="testimonial.url?.path">
          {{ testimonial.title }}
        </VuepalLink>
      </p>
    </div>
    <div v-if="display === 'standard'">
      <ParagraphTestimonialListStandard
        v-for="testimonial in filteredTestimonials"
        :key="testimonial.id"
        v-bind="testimonial"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ParagraphTestimonialListFragment } from '#graphql-operations'

defineProps<ParagraphTestimonialListFragment>()
defineBlokkli({
  bundle: 'testimonial_list',
})

// Get the data.
const { data: testimonials } = await useAsyncData(async () => {
  const variables = {}
  return useGraphqlQuery('testimonialList', variables).then((v) => {
    return v.data.entityQuery?.entities || []
  })
})

const nid = inject<string>('nid', '')

const filteredTestimonials = computed(() => {
  return (testimonials?.value ?? [])
    .filter(
      (testimonial): testimonial is NonNullable<typeof testimonial> =>
        !!testimonial && !!testimonial.id,
    )
    .filter((testimonial) => testimonial.id !== nid)
})
</script>

<style scoped lang="scss">
.testimonials {
  p {
    margin-bottom: 2rem;
  }
}
</style>
